import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

interface Finanzas2Option {
  title: string;
  description: string;
  icon: string;
  route: string;
  requiredRoles: string[];
  color: string; // Tailwind color class
  rbacPermissions?: string[];
}

@Component({
  selector: 'app-finanzas2-dashboard',
  templateUrl: './finanzas2-dashboard.component.html',
  styleUrls: []
})
export class Finanzas2DashboardComponent implements OnInit {
  options: Finanzas2Option[] = [
    {
      title: 'Verificación de Pagos',
      description: 'Visualiza todos los pagos realizados, filtrados por estatus y por método de pago',
      icon: 'fas fa-money-bill-wave',
      route: '/console/payments',
      requiredRoles: ['OWNER', 'ANALIST', 'ACCOUNTING_ANALYST'],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['finanzas.verificacion_pagos.read']
    }
  ];

  userRoles: string[] = [];

  constructor(public _auth: AuthService) {}

  ngOnInit(): void {
    this.userRoles = Array.isArray(this._auth.sessionUser?.profile) ? this._auth.sessionUser.profile : [];
  }

  hasPermission(option: Finanzas2Option): boolean {
    if (this._auth.hasRbac$.getValue()) {
      if (option.rbacPermissions && option.rbacPermissions.length > 0) {
        return this._auth.hasAnyPermission(option.rbacPermissions);
      }
      return this._auth.hasModuleAccess('finanzas');
    }
    if (!option.requiredRoles || option.requiredRoles.length === 0) return true;
    return option.requiredRoles.some(role => this.userRoles.includes(role));
  }
}
